import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../../../Paths";
import { useAppDispatch } from "../../../../state/store";
import { getListAction } from "../../../../state/usecase/care_recipient/actions";
import { registerCareRecipient } from "../../../../state/usecase/care_recipient/api";
import { orderErrorToast, orderSuccessToast } from "../../../funcs/orderResultToast";
import { InputTextBox } from "../../common/input/InputTextBox";
import { PrimaryButton } from "../../disease_knowledge/components/PrimaryButton";
import classes from "./AddCareRecipientPage.module.scss";
import { DateInput } from "../../common/input/DateInput";

export function AddCareRecipientPage() {

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");
    const [customerCode, setCustomerCode] = useState("");
    const [customerCodeError, setCustomerCodeError] = useState("");
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);

    const navigate = useNavigate();

    const dispatch = useAppDispatch();
 
    const validateInput = () => {
        setNameError("");
        setCustomerCodeError("");
        let valid = true;
        if (name.length === 0) {
            setNameError("名前を入力してください");
            valid = false;
        }
        if (customerCode.length === 0) {
            setCustomerCodeError("カスタマーコードを入力してください");
            valid = false;
        }
        return valid;
    };

    const onClick = async () => {
        if (!validateInput()) {
            return;
        }
        const successHandler = () => {
            dispatch(getListAction());
            orderSuccessToast("利用者を登録しました");
            navigate(Paths.careRecipient);
        };
        const failureHandler = (response: Response) => {
            if (response.status === 409) {
                setCustomerCodeError("すでに登録済のカスタマーコードです");
            }
            orderErrorToast("利用者登録に失敗しました");
        };
        await registerCareRecipient(name, customerCode, selectedDate, successHandler, failureHandler);
    };

    return (
        <div className={classes.container}>
            <div className={classes.input}>
                <div className={classes.label}>名前</div>
                <InputTextBox
                    value={name}
                    handleTextChanged={setName}
                    placeholder={"田中太郎"}
                    maxLength={60}
                    required
                    hasError={nameError.length > 0}
                />
                <div className={classes.errorMessage}>{nameError}</div>
            </div>
            <div className={classes.input}>
                <div className={classes.label}>カスタマーコード</div>
                <InputTextBox
                    value={customerCode}
                    handleTextChanged={setCustomerCode}
                    placeholder={"12345"}
                    maxLength={30}
                    required
                    hasError={customerCodeError.length > 0}
                />
                <div className={classes.errorMessage}>{customerCodeError}</div>
            </div>
            <div className={classes.input}>
                <div className={classes.label}>生年月日</div>
                <DateInput
                    value={selectedDate}
                    setValue={(d) => setSelectedDate(d)}
                />
            </div>
            <div className={classes.buttonArea}>
                <PrimaryButton onClick={onClick}>
                    登録
                </PrimaryButton>
            </div>
        </div>
    );
}

